<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
      <b-row>
        <b-col sm="12" md="12" lg="12">
          <div class="contenedorTablaSinColor">
            <b-table-simple class="sticky-header" responsive :style="datosTabla.length > 0 ?'height: 86vh;':'height: 0vh;'">
              <b-thead class="columnasTablaSinColor">
                <b-tr>
                  <b-th class="border-top-0" v-for="(field, index) in fields" :key="index">
                    {{ field.label }}
                  </b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(dato, index) in datosTabla" :key="index">
                  <b-td :style="((!dato.presentado && opcionPtiSeleccionada === 2) || (!dato.opcionAceptada && opcionPtiSeleccionada === 3)) ?'color: #a9a9a9;':''">{{ dato.etapa }}</b-td>
                  <b-td :style="((!dato.presentado && opcionPtiSeleccionada === 2) || (!dato.opcionAceptada && opcionPtiSeleccionada === 3)) ?'color: #a9a9a9;':''">{{ dato.od }}</b-td>
                  <b-td :style="((!dato.presentado && opcionPtiSeleccionada === 2) || (!dato.opcionAceptada && opcionPtiSeleccionada === 3)) ?'color: #a9a9a9;':''">{{ dato.padecimiento }}</b-td>
                  <b-td :style="((!dato.presentado && opcionPtiSeleccionada === 2) || (!dato.opcionAceptada && opcionPtiSeleccionada === 3)) ?'color: #a9a9a9;':''">{{ dato.tratamiento }}</b-td>
                  <b-td :style="((!dato.presentado && opcionPtiSeleccionada === 2) || (!dato.opcionAceptada && opcionPtiSeleccionada === 3)) ?'color: #a9a9a9;':''">{{ dato.cantidad }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <div align="center" v-if="loader">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <b-col v-if="!loader">
              <b-alert v-if="datosTabla === null || datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
            </b-col>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "PTIOriginal",
  data:()=>{
    return{
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loaderAcciones: false,
      fields:[
        {key: "etapa", label:"Detalle PTI", sortable: true},
        {key: "od", label:"Organo Dental Afectado", sortable: true},
        {key: "padecimiento", label:"Padecimiento", sortable: true},
        {key: "tratamiento", label:"Tratamiento / Condición clínica", sortable: true},
        {key: "cantidad", label:"Cantidad", sortable: true}
      ],

      pti:{
        detallePti:null,
        organoDental: null,
        padecimiento: null,
        tratamiento: null,
        cantidad: null
      },


      registrosPorPagina: 10,
      paginaActual: 0,
    }
  },

  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  props: {
    datosTabla: Array,
    loader: Boolean,
    opcionPtiSeleccionada: Number
  },
  methods:{
  }
}
</script>

<style scoped>
.contenedorTablaSinColor {
  padding: 8px;
  height: 88vh;
}
.table.b-table > thead > tr > .table-b-table-default {
  color: #5d5d5d !important;
  background-color: #ffffff !important;
}
.sticky-header {
  overflow-y: auto;
  /* max-height: 0px !important; */
}

</style>
